import React from 'react';
import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FaLeaf, FaBars, FaTimes, FaHome, FaProjectDiagram, FaCalendarAlt, FaImage, FaNewspaper, FaHandHoldingHeart, FaEnvelope, FaUser, FaSignOutAlt, FaBullhorn, FaUserFriends, FaBell, FaHandsHelping, FaVideo } from 'react-icons/fa';
import { notifyInfo } from '../utils/toast';

const Sidebar = () => {
    const [isOpen, setIsOpen] = useState(true);
    const location = useLocation();
    const navigate = useNavigate();

    const isActive = (path) => location.pathname === path;

    const handleLogout = () => {
        localStorage.removeItem('adminToken');
        localStorage.removeItem('admin');
        notifyInfo('Logged out successfully.');
        navigate('/admin/login');
    };

    return (
        <>
            {/* Mobile Menu Button */}
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="md:hidden fixed top-4 right-4 z-50 p-2 bg-emerald-600 text-white rounded-lg"
            >
                {isOpen ? <FaTimes /> : <FaBars />}
            </button>

            {/* Sidebar */}
            <aside className={`${isOpen ? 'block' : 'hidden'} md:block w-64 bg-gray-900 text-white min-h-screen fixed md:relative z-40`}>
                {/* Logo */}
                <div className="p-6 border-b border-gray-800 flex items-center gap-2">
                    <FaLeaf className="text-emerald-500 text-2xl" />
                    <span className="font-bold text-xl">YAP Admin</span>
                </div>

                {/* Navigation */}
                <nav className="p-6 space-y-2">
                    <Link
                        to="/admin/dashboard"
                        className={`flex items-center gap-3 px-4 py-3 rounded-lg transition ${isActive('/admin/dashboard')
                                ? 'bg-emerald-600 text-white'
                                : 'text-gray-300 hover:bg-gray-800'
                            }`}
                    >
                        <FaHome /> Dashboard
                    </Link>

                    <Link
                        to="/admin/projects"
                        className={`flex items-center gap-3 px-4 py-3 rounded-lg transition ${isActive('/admin/projects')
                                ? 'bg-emerald-600 text-white'
                                : 'text-gray-300 hover:bg-gray-800'
                            }`}
                    >
                        <FaProjectDiagram /> Projects
                    </Link>

                    <Link
                        to="/admin/events"
                        className={`flex items-center gap-3 px-4 py-3 rounded-lg transition ${isActive('/admin/events')
                                ? 'bg-emerald-600 text-white'
                                : 'text-gray-300 hover:bg-gray-800'
                            }`}
                    >
                        <FaCalendarAlt /> Events
                    </Link>

                    <Link
                        to="/admin/gallery"
                        className={`flex items-center gap-3 px-4 py-3 rounded-lg transition ${isActive('/admin/gallery')
                                ? 'bg-emerald-600 text-white'
                                : 'text-gray-300 hover:bg-gray-800'
                            }`}
                    >
                        <FaImage /> Gallery
                    </Link>

                    <Link
                        to="/admin/campaigns"
                        className={`flex items-center gap-3 px-4 py-3 rounded-lg transition ${isActive('/admin/campaigns')
                                ? 'bg-emerald-600 text-white'
                                : 'text-gray-300 hover:bg-gray-800'
                            }`}
                    >
                        <FaBullhorn /> Campaigns
                    </Link>

                    <Link
                        to="/admin/advisory-board"
                        className={`flex items-center gap-3 px-4 py-3 rounded-lg transition ${isActive('/admin/advisory-board')
                                ? 'bg-emerald-600 text-white'
                                : 'text-gray-300 hover:bg-gray-800'
                            }`}
                    >
                        <FaUserFriends /> Advisory Board
                    </Link>

                    <Link
                        to="/admin/popups"
                        className={`flex items-center gap-3 px-4 py-3 rounded-lg transition ${isActive('/admin/popups')
                                ? 'bg-emerald-600 text-white'
                                : 'text-gray-300 hover:bg-gray-800'
                            }`}
                    >
                        <FaBell /> Popup Alerts
                    </Link>

                    <Link
                        to="/admin/news"
                        className={`flex items-center gap-3 px-4 py-3 rounded-lg transition ${isActive('/admin/news') || isActive('/admin/blogs')
                                ? 'bg-emerald-600 text-white'
                                : 'text-gray-300 hover:bg-gray-800'
                            }`}
                    >
                        <FaNewspaper /> News
                    </Link>

                    <Link
                        to="/admin/donations"
                        className={`flex items-center gap-3 px-4 py-3 rounded-lg transition ${isActive('/admin/donations')
                                ? 'bg-emerald-600 text-white'
                                : 'text-gray-300 hover:bg-gray-800'
                            }`}
                    >
                        <FaHandHoldingHeart /> Donations
                    </Link>

                    <Link
                        to="/admin/contacts"
                        className={`flex items-center gap-3 px-4 py-3 rounded-lg transition ${isActive('/admin/contacts')
                                ? 'bg-emerald-600 text-white'
                                : 'text-gray-300 hover:bg-gray-800'
                            }`}
                    >
                        <FaEnvelope /> Contacts
                    </Link>

                    <Link
                        to="/admin/volunteers"
                        className={`flex items-center gap-3 px-4 py-3 rounded-lg transition ${isActive('/admin/volunteers')
                                ? 'bg-emerald-600 text-white'
                                : 'text-gray-300 hover:bg-gray-800'
                            }`}
                    >
                        <FaHandsHelping /> Volunteers
                    </Link>

                    <Link
                        to="/admin/home-settings"
                        className={`flex items-center gap-3 px-4 py-3 rounded-lg transition ${isActive('/admin/home-settings')
                                ? 'bg-emerald-600 text-white'
                                : 'text-gray-300 hover:bg-gray-800'
                            }`}
                    >
                        <FaVideo /> Home Settings
                    </Link>
                </nav>

                {/* Footer */}
                <div className="absolute bottom-0 w-full p-6 border-t border-gray-800 space-y-2">
                    <Link
                        to="/admin/profile"
                        className={`flex items-center gap-3 px-4 py-3 rounded-lg transition ${isActive('/admin/profile')
                                ? 'bg-emerald-600 text-white'
                                : 'text-gray-300 hover:bg-gray-800'
                            }`}
                    >
                        <FaUser /> Profile
                    </Link>
                    <button
                        onClick={handleLogout}
                        className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-gray-300 hover:bg-gray-800 transition"
                    >
                        <FaSignOutAlt /> Logout
                    </button>
                </div>
            </aside>

            {/* Overlay */}
            {isOpen && (
                <div
                    className="md:hidden fixed inset-0 bg-black opacity-50 z-30"
                    onClick={() => setIsOpen(false)}
                ></div>
            )}
        </>
    );
};

export default Sidebar;
